import * as React from 'react';
import { AuthContext } from '../../contextProviders/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

export default function BlockAccessIfNotSignedIn(): JSX.Element {
    const { isAuthenticated } = React.useContext(AuthContext);

    if (!isAuthenticated)
        return <Navigate to="/signin" replace />;

    return <Outlet />;
}
